import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PageComponent } from '@shared/components';
import { ContentPageId, FlowTypes, urlMapper } from '@shared/models';
import { OpenChoiceCommonContent } from '@shared/services/content/content-jsons/open-choice/open-choice-common.content';
import { RiskQuizSetupContent } from '@shared/services/content/content-jsons/open-choice/risk-quiz-setup.content';
import * as fromRootStore from '@store/index';
import { getFlowTypeSelection } from '@store/reducers/triage/triage.reducer';

@Component({
  selector: 'app-risk-quiz-setup',
  templateUrl: './risk-quiz-setup.component.html',
  styleUrl: './risk-quiz-setup.component.scss',
})
export class RiskQuizSetupComponent extends PageComponent implements OnInit, OnDestroy {
  content = RiskQuizSetupContent;
  openChoiceCommonContent = OpenChoiceCommonContent;
  flow: FlowTypes | null = null;

  constructor(globalStore: Store<fromRootStore.State>) {
    super(ContentPageId.riskquizsetup, globalStore);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subs.add(
      this.globalStore.pipe(select(fromRootStore.selectTriageState)).subscribe((triage) => {
        this.flow = getFlowTypeSelection(triage);
      }),
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  continue(): void {
    this.globalStore.dispatch(fromRootStore.Next());
  }

  errorHandler(event: CustomEvent): void {
    const errorDetails = JSON.stringify(event.detail);
    this.globalStore.dispatch(
      fromRootStore.LogError({
        payload: {
          eventId: 'open-choice-risk-quiz-setup--error',
          errorDetails,
        },
      }),
    );
    this.globalStore.dispatch(fromRootStore.rejectDAOffer());
    this.globalStore.dispatch(fromRootStore.UpdateDAComponentFailure({ payload: true }));
    if (this.flow === FlowTypes.MINOR) {
      this.globalStore.dispatch(
        fromRootStore.Go({ path: [`secure/${urlMapper[this.flow]}/review`] }),
      );
    } else {
      this.globalStore.dispatch(fromRootStore.Go({ path: ['error'] }));
    }
  }
}
